import React from "react";

export const EmailIcon = () => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.08344 7.17529L8.91984 12.0375C9.67193 12.5056 10.6239 12.5056 11.3786 12.0375L19.215 7.17529"
      stroke="#E4BDFF"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.77668 10.71L3.00836 14.9043"
      stroke="#E4BDFF"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.5191 10.71L17.2874 14.9043"
      stroke="#E4BDFF"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.6147 6.92827L10.9605 1.97134C10.4556 1.68208 9.83759 1.68208 9.3327 1.97134L0.681091 6.92827"
      stroke="#E4BDFF"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.8005 16.8421H1.76714C1.16758 16.8421 0.681091 16.3556 0.681091 15.756V6.92822M19.6147 6.92822V15.756C19.6147 16.3556 19.1282 16.8421 18.5286 16.8421H15.9936"
      stroke="#E4BDFF"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PhoneIcon = () => (
  <svg
    width="20"
    height="22"
    viewBox="0 0 20 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.2332 1.26074H5.76683C4.66509 1.26074 3.77196 2.14601 3.77196 3.23805V18.7617C3.77196 19.8538 4.66509 20.739 5.76683 20.739H14.2332C15.3349 20.739 16.2281 19.8538 16.2281 18.7617V3.23805C16.2281 2.14601 15.3349 1.26074 14.2332 1.26074Z"
      stroke="#E4BDFF"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.7043 3.47803H5.29573V16.9774H14.7043V3.47803Z"
      stroke="#E4BDFF"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.8459 2.33545H9.95131"
      stroke="#E4BDFF"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.2014 2.33545H11.4304"
      stroke="#E4BDFF"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.0303 18.9991C11.0303 19.5626 10.5698 20.0217 9.99869 20.0217C9.4276 20.0217 8.96704 19.5652 8.96704 18.9991C8.96704 18.4331 9.4276 17.9766 9.99869 17.9766C10.5698 17.9766 11.0303 18.4331 11.0303 18.9991Z"
      stroke="#E4BDFF"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FaxIcon = () => (
  <svg
    width="22"
    height="20"
    viewBox="0 0 22 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.03799 12.9941H14.962"
      stroke="#E4BDFF"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.03799 14.6621H14.962"
      stroke="#E4BDFF"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.03799 16.3296H14.962"
      stroke="#E4BDFF"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.53601 14.2442H1.61801C1.38801 14.2442 1.20001 14.0602 1.20001 13.8362V6.4532C1.20001 6.22723 1.38601 5.90527 1.61801 5.90527H20.384C20.614 5.90527 20.802 6.22723 20.802 6.4532V13.8362C20.802 14.0622 20.616 14.2442 20.384 14.2442H17.464"
      stroke="#E4BDFF"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.53601 11.4863V18.7474H17.464V11.4863"
      stroke="#E4BDFF"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.28601 7.99072H6.20401"
      stroke="#E4BDFF"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.53601 12.576H3.28601V11.3262H18.714V12.576H17.464"
      stroke="#E4BDFF"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.464 0.901855H4.53601V5.9052H17.464V0.901855Z"
      stroke="#E4BDFF"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const InstaIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_552_479)">
      <path
        d="M5.29218 0.584961H14.7072C17.3069 0.584961 19.4151 2.69235 19.4152 5.29199V14.707C19.4152 17.3068 17.307 19.415 14.7072 19.415H5.29218C2.69253 19.4149 0.585144 17.3067 0.585144 14.707V5.29199C0.585272 2.69243 2.69261 0.585089 5.29218 0.584961Z"
        stroke="#E4BDFF"
        strokeMiterlimit="10"
      />
      <path
        d="M10 14.8766C12.6934 14.8766 14.8768 12.6932 14.8768 9.99982C14.8768 7.30645 12.6934 5.12305 10 5.12305C7.30664 5.12305 5.12323 7.30645 5.12323 9.99982C5.12323 12.6932 7.30664 14.8766 10 14.8766Z"
        stroke="#E4BDFF"
        strokeMiterlimit="10"
      />
      <path
        d="M15.9292 5.13702C16.5235 5.13702 17.0053 4.65524 17.0053 4.06094C17.0053 3.46664 16.5235 2.98486 15.9292 2.98486C15.3349 2.98486 14.8531 3.46664 14.8531 4.06094C14.8531 4.65524 15.3349 5.13702 15.9292 5.13702Z"
        fill="#E4BDFF"
      />
    </g>
    <defs>
      <clipPath id="clip0_552_479">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
